import {HIDE_ERROR} from "../types/types";
import {
    CLEAR_STATUS_STATISTICS_FILTERS,
    GET_STATUS_STATISTIC,
    SET_CURRENT_STATUS_STATISTICS_PAGE,
    SET_CURRENT_STATUS_STATISTICS_SIZE,
    SET_FIRST_PAGE,
    SET_STATUS_STATISTICS_FILTER, SET_STATUS_STATISTICS_LOADING,
    SHOW_EXPORT_STATUS_STATISTICS_LOADING, UPDATE_STATUS_STATISTIC_FILTER
} from "../types/typesStatusStatisticsList";
import {UPDATE_STATISTIC_FILTER} from "../types/typesCallsStatisticsList";


export function setStatusStatisticsCurrentPage(state: any) {
    return {
        type: SET_CURRENT_STATUS_STATISTICS_PAGE,
        payload: state
    }
}

export function setStatusStatisticsCurrentPageSize(state: any) {
    return {
        type: SET_CURRENT_STATUS_STATISTICS_SIZE,
        payload: state
    }
}

export function setPageForFirst(state: any) {
    return {
        type: SET_FIRST_PAGE,
        payload: state
    }
}

export function showStatusStatisticsExportLoader(state: boolean) {
    return {
        type: SHOW_EXPORT_STATUS_STATISTICS_LOADING,
        payload: state
    }
}


export function hideError() {
    return {
        type: HIDE_ERROR,
    }
}

export function setStatusStatisticsFilter(payload: any) {
    return {
        type: SET_STATUS_STATISTICS_FILTER,
        payload: payload,
    };
}

export function showStatusStatisticsLoader(payload: any) {
    return {
        type: SET_STATUS_STATISTICS_LOADING,
        payload: payload,
    };
}

export const updateStatusStatisticFilter = (field: string, value: any) => ({
    type: UPDATE_STATUS_STATISTIC_FILTER,
    payload: { field, value }
});
export function getUserStatusDetailsInfo(data: any) {
    return {
        type: GET_STATUS_STATISTIC,
        payload: data,
    };
}

export const resetStatusStatisticFilters = () => ({
    type: CLEAR_STATUS_STATISTICS_FILTERS
});

